export { Configs } from './configs';
export { DateObjectInput, DateInput, TimeInput, NumberWithConfigInput } from './utils';
export {
  DateStyles,
  NumberStyle,
  NumberStyles,
  DateTimeStyles,
  TimeZoneNames,
  UnitStyles,
  UnitType,
  UnitTypes,
  RelativeStyles
} from './styles';
export { DateFormat, Formats, TimeFormat } from './formats';
export { I18nextProps, LanguageSwitcherParent, LanguageSwitcherParentTypes } from './i18n';
export { Indexes, Translation } from './localizedResponse';

export enum Language {
  En = 'en',
  Fr = 'fr',
  De = 'de',
  Es = 'es',
  Pt = 'pt',
  It = 'it',
  Ro = 'ro',
  Nl = 'nl'
}
